import { insert, join, splitAt } from 'ramda';
import React, { ChangeEventHandler, forwardRef, useState } from 'react';
import styled from 'styled-components';

import TextInput, { IStyledTextInputProps } from '@ui/forms/TextInput';

interface IZipTextInputProps extends IStyledTextInputProps {}

const ZipTextInput = forwardRef<HTMLInputElement, IZipTextInputProps>(({ ...props }, ref) => {
	const [value, setValue] = useState(props?.value);

	const formatZipCode: ChangeEventHandler<HTMLInputElement> = (event) => {
		let parsedValue = event.target.value;
		parsedValue = parsedValue.replace(/[^0-9]/g, '');

		if (parsedValue.length > 5) {
			parsedValue = join('-')(splitAt(5, parsedValue));
		}

		setValue(parsedValue);
		props?.onChange?.(event);
	};

	return <TextInput {...props} ref={ref} onChange={formatZipCode} value={value}></TextInput>;
});

ZipTextInput.displayName = 'ZipTextInput';
export default styled(ZipTextInput)``;
